<template>
  <nav class="nav navbar navbar-expand-lg bg-self-dark navbar-dark">
    <router-link to="/home" class="navbar-brand logo" href="#">
      <img src="../assets/images/logo.png" alt />
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarList"
      aria-controls="navbarList"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarList">
      <div class="navbar-nav ml-auto">
        <router-link
          v-for="item in data"
          :to="item.link"
          class="nav-item nav-link"
          :key="item.title"
          exact
          data-toggle="collapse"
          :data-target="$isMobile ? '#navbarList' : ''"
          >{{ item.title }}</router-link
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "cus-nav",
  data() {
    return {
      router: this.$route,
      data: [
        {
          title: "首页",
          link: "/"
        },
        {
          title: "应急装备系统",
          link: "/products"
        },
        {
          title: "AI安防产品",
          link: "/experience"
        },
        {
          title: "AI解决方案",
          link: "/AI"
        },
		{
		  title: "定制产品研发",
		  link: "/brand"
		},
        {
          title: "关于我们",
          link: "/about"
        },
       
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.nav {
  height: 74px;
  &.navbar {
    padding: 0 12%;
  }

  .logo {
	display: flex;
	align-items: center;
	height: 100%;
    padding-top: 0.9rem;
    text-align: left;
	img{
		width: 40%;
	}
  }
  .navbar-nav {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 80%;
    padding-top: 0.6rem;

    .nav-link {
      color: #c9c9c9;
      font-size: 1rem;
      line-height: 1;

      &.router-link-active {
        border-bottom: 2px solid #000;
      }
    }
  }

  .dropdown-toggle::after {
    opacity: 0;
  }
}
.bg-self-dark {
  background: rgba(55, 55, 55, 0.7);
}
@include media-breakpoint-down(md) {
  .bg-self-dark {
    background: rgba(55, 55, 55, 1);
  }
  .nav {
    width: 100%;
    height: auto;
    &.navbar {
      padding: 0.5rem 1rem;
    }
    .logo {
      padding: 0;
      width: auto;
      img {
        width: 100px;
      }
    }
    .navbar-collapse {
      padding-bottom: 5rem;
    }
    .navbar-nav {
      width: 100%;

      .nav-link {
        font-size: 1rem;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #818181;
        line-height: 2rem;
        &.router-link-active {
          background: none;
          border-radius: 0px;
        }
      }
    }
  }
}
</style>
